import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { EditProfileDialog } from "./EditProfileDialog";
import { ProfileHeader } from "./profile/ProfileHeader";
import { ProfileProgress } from "./profile/ProfileProgress";
import { useProfile } from "@/hooks/useProfile";
import { ProfileCardSkeleton } from "@/components/common/skeletons";

export function ProfileOverview() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { profile, isLoading } = useProfile();

  useEffect(() => {
    if (searchParams.get("edit") === "1") {
      setIsDialogOpen(true);
      const next = new URLSearchParams(searchParams);
      next.delete("edit");
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams]);


  const profileData = {
    description: profile?.description || "",
    skills: profile?.skills || [],
    photoUrl: profile?.photoUrl || null,
    full_name: profile?.full_name || null,
    headline: profile?.headline || null,
    location: profile?.location || null,
    experience_level: profile?.experience_level || null,
    linkedin_url: profile?.linkedin_url || null,
    github_url: profile?.github_url || null,
    portfolio_url: profile?.portfolio_url || null,
    instagram_url: profile?.instagram_url || null,
  };

  if (isLoading) {
    return (
      <div className="w-full px-4 sm:px-0 max-w-4xl mx-auto">
        <ProfileCardSkeleton />
      </div>
    );
  }

  return (
    <div className="w-full px-4 sm:px-0 max-w-4xl mx-auto">
      <Card className="shadow-lg hover:shadow-xl transition-shadow duration-300">
        <CardHeader className="space-y-1 px-4 sm:px-6">
          <CardTitle className="text-2xl font-bold text-foreground">Seu Perfil</CardTitle>
        </CardHeader>
        <CardContent className="px-4 sm:px-6">
          <ProfileProgress
            profile={profileData}
            onEditClick={() => setIsDialogOpen(true)}
          />
          <ProfileHeader
            profile={profileData}
            onEditClick={() => setIsDialogOpen(true)}
          />
        </CardContent>
      </Card>

      <EditProfileDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
      />
    </div>
  );
}